import React from 'react'

const ParticularsRecipients = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>Particulars of recipients of concessions, permits or authorization granted by it</h5>
    </div>

    <div
      className="about-box p-4 rounded shadow-lg "
      style={{ textAlign: "justify" }}
    >
    <p>The distribution of subsidy on certifide seeds is received by the Farmers of Haryana State .</p>
  </div>
  </div>
  )
}

export default ParticularsRecipients
